<script setup lang="ts">
import TopBar from "./TopBar.vue"
import Sidebar from "./Sidebar.vue"
import { useAuthStore } from "../stores/auth"

const auth = useAuthStore()
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <TopBar />
    <div class="flex-1 flex">
      <Sidebar v-if="auth.signedIn" />
      <main class="flex-1 p-8 max-w-7xl mx-auto w-full">
        <slot />
      </main>
    </div>
    <footer class="text-xs text-ink-muted px-6 py-3 border-t border-rule flex justify-between">
      <span>© 2026 Cyntegrity · Mission Control · {{ env }}</span>
      <span class="italic text-orange">Building Trust in Every Interaction</span>
    </footer>
  </div>
</template>

<script lang="ts">
const env = (import.meta.env.MODE === "development" ? "dev (local)" : (import.meta.env.VITE_MC_ENV || "dev"))
export default { name: "AppShell" }
</script>
